import { render } from "./ModalBusiness.vue?vue&type=template&id=4729bcfb&scoped=true"
import script from "./ModalBusiness.vue?vue&type=script&lang=js"
export * from "./ModalBusiness.vue?vue&type=script&lang=js"

import "./ModalBusiness.vue?vue&type=style&index=0&id=4729bcfb&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4729bcfb"]])

export default __exports__